import React, { useEffect } from "react";
import SearchPageNavigation from "./SearchPageNavigation";

export type PageNavigation = {
  resTotal: number;
  skip: number;
  limit: number;
  pageNavigationHandle: Function;
  rowsPerPageHandle?: Function;
};

export type SearchResultListProps<T> = {
  renderSingle: Function;
  results: T[];
  pageNavigation?: PageNavigation;
};

function SearchResultList<T>({
  renderSingle,
  results,
  pageNavigation,
}: SearchResultListProps<T>) {
  // useEffect(() => {
  //   console.log("pageNavigation", pageNavigation);
  // }, [pageNavigation]);

  return (
    <>
      {pageNavigation && <SearchPageNavigation {...pageNavigation} />}
      {results.length > 0 &&
        results.map((result: T, ind: number) => {
          return renderSingle(result, ind);
        })}
      {pageNavigation && <SearchPageNavigation {...pageNavigation} />}
    </>
  );
}

export default SearchResultList;
